import { Sun, Moon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../providers/ThemeProvider'

export function ThemeToggle() {
  const { t } = useTranslation('components')
  const { resolvedTheme, setTheme } = useTheme()
  const isDark = resolvedTheme === 'dark'

  return (
    <button
      className="theme-toggle"
      aria-pressed={isDark}
      aria-label={t('themeToggle.ariaLabel')}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      <span>{isDark ? t('themeToggle.dark') : t('themeToggle.light')}</span>
      <span className="puck">
        {isDark ? <Moon size={12} /> : <Sun size={12} />}
      </span>
    </button>
  )
}
